import http from '@/utils/http'
import httpApi from '@/apis/httpApi'
import pageApi from '@/apis/pageApi'

export const logout = async () => {
  let res = await http.post({
    url: httpApi.user.logout,
  })
  if (res.code == 200) {
    window.$APP.$router.push({ path: pageApi.login.path })
  }
}

export const getLogin = ({ username, password, smsCode, uuid }) => {
  return http.post({
    url: httpApi.user.login,
    data: {
      username,
      password,
      smsCode,
      uuid,
    },
  })
}

export const getLoginSms = ({ passportName, imgCode, pwd }) => {
  return http.post({
    url: httpApi.user.getLoginSms,
    data: {
      passportName,
      imgCode,
      pwd,
    },
  })
}

export const toRegister = ({ passportMobile, passportCode }) => {
  return http.post({
    url: httpApi.user.toRegister,
    data: {
      passportMobile,
      passportCode,
    },
  })
}

export const getCode = ({ phone, imgCode }) => {
  return http.post({
    url: httpApi.user.registeredSmsCode,
    data: {
      phone,
      imgCode,
    },
  })
}

export const getPhoneCode = ({ passport_mobile, passport_code }) => {
  return http.post({
    url: httpApi.user.register,
    data: {
      passport_mobile,
      passport_code,
    },
  })
}

export const getRegister = ({
  passportName,
  passportPassword,
  passportMobile,
  passportCode,
  passportQq,
  personalName,
}) => {
  return http.post({
    url: httpApi.user.register,
    data: {
      passportName,
      passportPassword,
      passportMobile,
      passportCode,
      passportQq,
      personalName,
    },
  })
}

export const getfForgetSmsCode = ({ phone, imgCode, passportName }) => {
  return http.post({
    url: httpApi.user.forgetSmsCode,
    data: {
      phone,
      imgCode,
      passportName,
    },
  })
}

export const getForgetPwd = ({
  passportName,
  password,
  passportMobile,
  verifyPassword,
  smsCode,
}) => {
  return http.post({
    url: httpApi.user.forgetPwd,
    data: {
      passportName,
      password,
      verifyPassword,
      passportMobile,
      smsCode,
    },
  })
}

export const getCity = ({ grep, pfid }) => {
  return http.post({
    url: httpApi.user.getCity,
    data: {
      grep,
      pfid,
    },
  })
}

export const updateUserInfo = ({
  personalName,
  cityId,
  passportMail,
  personalQQ,
  address,
  companyName,
}) => {
  return http.post({
    url: httpApi.user.updateUserInfo,
    data: {
      personalName,
      cityId,
      passportMail,
      personalQQ,
      address,
      companyName,
    },
  })
}

export const loginWx = ({
  passportName,
  passportPassword,
  smsCode,
  wxhash,
}) => {
  return http.post({
    url: httpApi.user.loginWx,
    data: {
      passportName,
      passportPassword,
      smsCode,
      wxhash,
    },
  })
}

export const sendWxSmsCode = () => {
  return http.post({
    url: httpApi.user.sendWxSmsCode,
  })
}
// 获取滑块验证码
export const getDragImage = () => {
  return http.post({
    url: httpApi.user.getDragImage,
  })
}

// 账号解冻——1.获取短信
export const getUnFreezeSms = ({ passportName, imgCode }) => {
  return http.post({
    url: httpApi.user.getUnFreezeSms,
    data: {
      passportName,
      imgCode,
    },
  })
}
// 账号解冻——2.解冻
export const unfreezeAccount = ({ passportName, smsCode }) => {
  return http.post({
    url: httpApi.user.unfreezeAccount,
    data: {
      passportName,
      smsCode,
    },
  })
}

export const getUserInfo = () => {
  return http.get({
    url: httpApi.user.getUserInfo,
    data: {},
  })
}

export const sendWxBindSmsCode = ({ passportName, password }) => {
  return http.post({
    url: httpApi.user.sendWxBindSmsCode,
    data: {
      passportName,
      password,
    },
  })
}

export const advice = ({ issue, email, acceptVisit }) => {
  return http.post({
    url: httpApi.user.advice,
    data: {
      issue,
      email,
      acceptVisit,
    },
  })
}
// 开通vip
export const openVip = ({ vipType, duration, payType }) => {
  return http.post({
    url: httpApi.user.openVip,
    data: {
      vipType,
      duration,
      payType,
    },
  })
}
// 免费试用
export const freeTrial = ({ passportName }) => {
  return http.post({
    url: httpApi.user.freeTrial,
    data: {
      passportName,
    },
  })
}
// 设置OEM信息
export const setOEMInformation = ({
  id,
  domainType,
  domainName,
  webTitle,
  beforeLoginLogo,
  afterLoginLogo,
}) => {
  return http.post({
    url: httpApi.user.setOEMInformation,
    data: {
      id,
      domainType,
      domainName,
      webTitle,
      beforeLoginLogo,
      afterLoginLogo,
    },
  })
}
// 上传图片
export const uploadImg = ({ file }) => {
  return http.post({
    url: httpApi.user.uploadImg,
    data: {
      file,
    },
  })
}
// 获取oem信息
export const getOEMInformation = () => {
  return http.get({
    url: httpApi.user.getOEMInformation,
  })
}
export const getByReferer = () => {
  return http.get({
    url: httpApi.user.getByReferer,
  })
}

// 获取VIP列表
export const getVipList = () => {
  return http.get({
    url: httpApi.user.getVipList,
  })
}
